export function MyInterviewSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/my-interview.svg'"></ng-include>`
    }
}